import React from "react";
import { toast } from "react-toastify";
import { Link } from "react-router-dom";
import ls from "local-storage";
import RV from "simple-react-validator";
import * as CONFIG from "./_config";
toast.configure();
const axios = require("axios");

class Changepin extends React.Component {
  constructor(props) {
    super(props);
    this.validator = new RV();
    this.validator.visibleFields = [];
    this.state = {
      formControls: {
        old_pin: "",
        new_pin: "",
      },
    };
  }

  logout(e) {
    var redirectTo = ls.get("redirectTo");
    ls.remove(`userdata${CONFIG.DATA.RSA_SUBDOMAIN}`);
    ls.remove("ClientStores");
    ls.remove("Departments");
    ls.clear();

    this.props.history.push("/login");
    // this.showLogin();

    ls.set("redirectTo", redirectTo);
    window.location.reload();
  }
  changeHandler = (event) => {
    // console.log(event);

    const name = event.target.name;
    const value = event.target.value;
    this.setState({
      formControls: { ...this.state.formControls, [name]: value },
    });
  };

  changeNumericHandler = (event) => {
    const name = event.target.name;
    const value = event.target.value;
    const isNumValue = !isNaN(value) ? value : "";

    this.setState({
      formControls: {
        ...this.state.formControls,
        [name]: isNumValue,
      },
    });
  };

  componentDidMount() {
    ls.set("redirectTo", window.location.href);
  }

  UpdateAccount = async (e) => {
    // console.log(this.state);

    e.preventDefault();

    //console.log( this.validator.getErrorMessages())

    if (!this.validator.allValid()) {
      this.validator.showMessages();
      this.forceUpdate();
      return false;
    }

    var UserToken = ls.get(`userdata${CONFIG.DATA.RSA_SUBDOMAIN}`)
      ? ls.get(`userdata${CONFIG.DATA.RSA_SUBDOMAIN}`).UserToken
      : "";
    var CustomerId = ls.get(`userdata${CONFIG.DATA.RSA_SUBDOMAIN}`)
      ? ls.get(`userdata${CONFIG.DATA.RSA_SUBDOMAIN}`).CustomerId
      : "";
    const data = new FormData();
    data.append("method", "POST");

    const apiurl = `https://ra14ql4rs6.execute-api.us-east-1.amazonaws.com/prod/ChangePassword`;
    // data.append(
    //   "apiurl",
    //   `https://${CONFIG.DATA.RSA_SUBDOMAIN}.rsaamerica.com/Services/SSWebRestApi.svc/ChangePassword`
    // );
    data.append("OldPassword", this.state.formControls.old_password);
    data.append("NewPassword", this.state.formControls.new_password);
    data.append("CustomerId", CustomerId);
    data.append("UserToken", UserToken);

    var object = {};
    data.forEach((value, key) => (object[key] = value));
    var jsonData = JSON.stringify(object);

    axios
      .post(apiurl, jsonData, {
        headers: { domainname: CONFIG.DATA.RSA_SUBDOMAIN },
      })
      .then((res) => {
        // console.log('res',res.data);return;

        if (res.status === 200) {
          if (res.data.ErrorMessage.ErrorCode <= 0) {
            toast.error(res.data.ErrorMessage.ErrorDetails, {
              autoClose: 2000,
            });

            setTimeout(() => {
              window.location.reload();
            }, 2500);
          } else {
            toast.success(res.data.ErrorMessage.ErrorDetails, {
              autoClose: 2000,
            });
            setTimeout(() => {
              this.logout();
            }, 2500);
          }
        }
        // if (res.data.ErrorMessage.ErrorCode <= 0) {
        //   toast.error(res.data.ErrorMessage.ErrorDetails);
        // }
        // else {
        //   this.setState({
        //     formControls: {},
        //   });

        //   toast.success(res.data.ErrorMessage.ErrorDetails, {
        //     autoClose: 2000,
        //   });

        //   document.getElementById("changepin").reset();
        // }
      })
      .catch(function (ress) {
        console.log(ress);
        toast.error("Error Notification !");
      });
  };

  render() {
    return (
      <div className="main-container full-width pt-5 mt-5">
        {CONFIG.DATA.THEME === 2 ? (
          <section
            id="apus-breadscrumb"
            className="breadcrumb-page apus-breadscrumb"
            style={{ backgroundColor: "#f3ffd9" }}
          >
            <div className="container">
              <div className="wrapper-breads">
                <div className="wrapper-breads-inner">
                  <div className="breadscrumb-inner">
                    <h2 className="bread-title">
                      {CONFIG.DATA.ALLOW_PASSWORD ||
                      CONFIG.DATA.RSA_SUBDOMAIN === "sandssupermarket" ||
                      CONFIG.DATA.RSA_SUBDOMAIN === "lowessignature" ||
                      CONFIG.DATA.RSA_SUBDOMAIN === "lowesmarket" ||
                      CONFIG.DATA.RSA_SUBDOMAIN === "bakerfoodspw"
                        ? "Change Password"
                        : "Change Pin"}
                    </h2>
                    <ol className="breadcrumb">
                      <li>
                        <a href={CONFIG.DATA.BASEPATH}>Home</a>
                      </li>
                      <li>
                        <span>My account</span>
                      </li>
                      <li>
                        <span className="active">
                          {CONFIG.DATA.ALLOW_PASSWORD ||
                          CONFIG.DATA.RSA_SUBDOMAIN === "sandssupermarket" ||
                          CONFIG.DATA.RSA_SUBDOMAIN === "lowessignature" ||
                          CONFIG.DATA.RSA_SUBDOMAIN === "lowesmarket" ||
                          CONFIG.DATA.RSA_SUBDOMAIN === "bakerfoodspw"
                            ? "Change Password"
                            : "Change Pin"}
                        </span>
                      </li>
                    </ol>
                  </div>
                </div>
              </div>
            </div>
          </section>
        ) : (
          <div className="title-breadcrumb">
            <div className="container">
              <div className="title-breadcrumb-inner">
                <header className="entry-header">
                  <h1 className="entry-title">
                    {CONFIG.DATA.ALLOW_PASSWORD ||
                    CONFIG.DATA.RSA_SUBDOMAIN === "sandssupermarket" ||
                    CONFIG.DATA.RSA_SUBDOMAIN === "lowessignature" ||
                    CONFIG.DATA.RSA_SUBDOMAIN === "lowesmarket" ||
                    CONFIG.DATA.RSA_SUBDOMAIN === "bakerfoodspw"
                      ? "Change Password"
                      : "Change Pin"}
                  </h1>
                </header>
                <div className="breadcrumbs">
                  <Link to="/">Home</Link>
                  <span className="separator">/</span>
                  <span>
                    {CONFIG.DATA.ALLOW_PASSWORD ||
                    CONFIG.DATA.RSA_SUBDOMAIN === "sandssupermarket" ||
                    CONFIG.DATA.RSA_SUBDOMAIN === "lowessignature" ||
                    CONFIG.DATA.RSA_SUBDOMAIN === "lowesmarket" ||
                    CONFIG.DATA.RSA_SUBDOMAIN === "bakerfoodspw"
                      ? "Change Password"
                      : "Change Pin"}
                  </span>
                </div>
              </div>
            </div>
          </div>
        )}
        <div className="page-content">
          <div className="container">
            <article
              id="post-22"
              className="post-22 page type-page status-publish hentry"
            >
              <div className="entry-content">
                <div
                  className="vc_row wpb_row vc_row-fluid"
                  style={{ marginTop: "40px" }}
                >
                  <div
                    className="row-container"
                    style={{
                      border: "1px solid #d3ced2",
                      padding: 20,
                      //  margin: "2em 0",
                      textAlign: "left",
                      borderRadius: 5,
                      width: "800px",
                      margin: "0px auto",
                    }}
                  >
                    <div className="wpb_column vc_column_container vc_col-sm-12">
                      <div className="vc_column-inner">
                        <div className="wpb_wrapper">
                          <div className="wpforms-container wpforms-container-full">
                            <div className="woocommerce-notices-wrapper" />
                            <form
                              method="post"
                              className="wpforms-validate wpforms-form"
                              id="changepin"
                            >
                              <div className="wpforms-field-container">
                                <div
                                  id="wpforms-8464-field_1-container"
                                  className="wpforms-field wpforms-field-text wpforms-one-half wpforms-first"
                                  data-field-id="1"
                                >
                                  <label
                                    className="wpforms-field-label"
                                    htmlFor="wpforms-8464-field_1"
                                  >
                                    {CONFIG.DATA.ALLOW_PASSWORD ||
                                    CONFIG.DATA.RSA_SUBDOMAIN ===
                                      "sandssupermarket" ||
                                    CONFIG.DATA.RSA_SUBDOMAIN ===
                                      "superiorgrocers"
                                      ? "Old Password"
                                      : "Old PIN"}
                                    <span className="wpforms-required-label">
                                      *
                                    </span>
                                  </label>

                                  {CONFIG.DATA.ALLOW_PASSWORD ||
                                  CONFIG.DATA.RSA_SUBDOMAIN ===
                                    "sandssupermarket" ||
                                  CONFIG.DATA.RSA_SUBDOMAIN ===
                                    "superiorgrocers" ? (
                                    <>
                                      <input
                                        onChange={(e) => this.changeHandler(e)}
                                        type="password"
                                        id="old_password"
                                        className="wpforms-field-large wpforms-field-required"
                                        name="old_password"
                                        required="required"
                                        minLength={4}
                                        maxLength={12}
                                      />
                                      <span className="text-danger float-left">
                                        {this.validator.message(
                                          "old_password",
                                          this.state.formControls.old_password,
                                          "required|min:4|max:12"
                                        )}
                                      </span>
                                    </>
                                  ) : (
                                    <>
                                      <input
                                        onChange={(e) => this.changeHandler(e)}
                                        type="password"
                                        id="old_password"
                                        className="wpforms-field-large wpforms-field-required"
                                        name="old_password"
                                        required="required"
                                        minLength={4}
                                        maxLength={4}
                                      />
                                      <span className="text-danger float-left">
                                        {this.validator.message(
                                          "old_pin",
                                          this.state.formControls.old_password,
                                          "required|min:4|max:4"
                                        )}
                                      </span>
                                    </>
                                  )}
                                </div>

                                <div
                                  id="wpforms-8464-field_3-container"
                                  className="wpforms-field wpforms-field-text wpforms-one-half wpforms-first"
                                  data-field-id="3"
                                >
                                  <label
                                    className="wpforms-field-label"
                                    htmlFor="wpforms-8464-field_3"
                                  >
                                    {CONFIG.DATA.ALLOW_PASSWORD ||
                                    CONFIG.DATA.RSA_SUBDOMAIN ===
                                      "sandssupermarket" ||
                                    CONFIG.DATA.RSA_SUBDOMAIN ===
                                      "superiorgrocers" ||
                                    CONFIG.DATA.RSA_SUBDOMAIN ===
                                      "brooksgrocery" ||
                                    CONFIG.DATA.RSA_SUBDOMAIN === "bakerfoodspw"
                                      ? "New Password"
                                      : "New PIN"}

                                    <span className="wpforms-required-label">
                                      *
                                    </span>
                                  </label>
                                  {CONFIG.DATA.ALLOW_PASSWORD ||
                                  CONFIG.DATA.RSA_SUBDOMAIN ===
                                    "sandssupermarket" ||
                                  CONFIG.DATA.RSA_SUBDOMAIN ===
                                    "superiorgrocers" ||
                                  CONFIG.DATA.RSA_SUBDOMAIN ===
                                    "brooksgrocery" ||
                                  CONFIG.DATA.RSA_SUBDOMAIN ===
                                    "bakerfoodspw" ? (
                                    <>
                                      <input
                                        type="password"
                                        id="new_password"
                                        className="wpforms-field-large wpforms-field-required"
                                        name="new_password"
                                        required="required"
                                        value={
                                          this.state.formControls.new_password
                                        }
                                        onChange={this.changeHandler}
                                        onKeyUp={this.EnterkeyEvent}
                                        // pattern="[0-9]*" inputMode="numeric"
                                        maxLength="12"
                                        minLength={6}
                                      />
                                      <span className="text-danger float-left">
                                        {this.validator.message(
                                          "new_password",
                                          this.state.formControls.new_password,
                                          "required|min:6|max:12"
                                        )}
                                      </span>
                                    </>
                                  ) : (
                                    <>
                                      <input
                                        onChange={(e) =>
                                          this.changeNumericHandler(e)
                                        }
                                        type="password"
                                        id="password"
                                        className="wpforms-field-large wpforms-field-required"
                                        name="new_password"
                                        required=""
                                        maxLength={4}
                                        minLength={4}
                                        value={
                                          this.state.formControls.new_password
                                        }
                                      />
                                      <span className="text-danger float-left">
                                        {this.validator.message(
                                          "new_pin",
                                          this.state.formControls.new_password,
                                          "required|min:4|max:4"
                                        )}
                                      </span>
                                    </>
                                  )}
                                </div>
                                <div
                                  id="wpforms-8464-field_3-container"
                                  className="wpforms-field wpforms-field-email wpforms-one-half"
                                  data-field-id="3"
                                >
                                  <label
                                    className="wpforms-field-label"
                                    htmlFor="client_store"
                                  >
                                    {CONFIG.DATA.ALLOW_PASSWORD ||
                                    CONFIG.DATA.RSA_SUBDOMAIN ===
                                      "sandssupermarket" ||
                                    CONFIG.DATA.RSA_SUBDOMAIN ===
                                      "superiorgrocers" ||
                                    CONFIG.DATA.RSA_SUBDOMAIN === "bakerfoodspw"
                                      ? "Confirm Password"
                                      : "Confirm PIN"}

                                    <span className="wpforms-required-label">
                                      *
                                    </span>
                                  </label>

                                  {CONFIG.DATA.ALLOW_PASSWORD ||
                                  CONFIG.DATA.RSA_SUBDOMAIN ===
                                    "sandssupermarket" ||
                                  CONFIG.DATA.RSA_SUBDOMAIN ===
                                    "superiorgrocers" ||
                                  CONFIG.DATA.RSA_SUBDOMAIN ===
                                    "bakerfoodspw" ? (
                                    <>
                                      <input
                                        onChange={(e) => this.changeHandler(e)}
                                        type="password"
                                        id="repassword"
                                        className="wpforms-field-large wpforms-field-required"
                                        name="confirm_password"
                                        required=""
                                        maxLength={12}
                                        minLength={6}
                                      />
                                      <span className="text-danger float-left">
                                        {this.validator.message(
                                          "confirm_password",
                                          this.state.formControls
                                            .confirm_password,
                                          `required|min:6|max:12|in:${this.state.formControls.new_password}`,
                                          {
                                            messages: {
                                              in: "Passwords need to match!",
                                            },
                                          }
                                        )}
                                      </span>
                                    </>
                                  ) : (
                                    <>
                                      <input
                                        onChange={(e) =>
                                          this.changeNumericHandler(e)
                                        }
                                        type="password"
                                        id="repassword"
                                        className="wpforms-field-large wpforms-field-required"
                                        name="confirm_password"
                                        required=""
                                        minLength={4}
                                        maxLength={4}
                                        value={
                                          this.state.formControls
                                            .confirm_password
                                        }
                                      />
                                      <span className="text-danger float-left">
                                        {this.validator.message(
                                          "confirm_pin",
                                          this.state.formControls
                                            .confirm_password,
                                          `required|numeric|min:4|max:4|in:${this.state.formControls.new_password}`,
                                          {
                                            messages: {
                                              in: "PINs need to match!",
                                            },
                                          }
                                        )}
                                      </span>
                                    </>
                                  )}
                                </div>

                                <div
                                  id="wpforms-8464-field_3-container"
                                  className="wpforms-field wpforms-field-email wpforms-one-third wpforms-first"
                                  data-field-id="3"
                                >
                                  <button
                                    type="submit"
                                    name="change_pin_button"
                                    className="wpforms-submit btn btn-success mr-1"
                                    id="change_pin_button"
                                    value="wpforms-submit"
                                    aria-live="assertive"
                                    data-alt-text="Sending..."
                                    data-submit-text="Change PIN"
                                    onClick={(e) => this.UpdateAccount(e)}
                                  >
                                    Submit
                                  </button>
                                </div>
                              </div>
                            </form>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </article>
          </div>
        </div>
      </div>
    );
  }
}
export default Changepin;
